import { useState, useEffect, useRef } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from '@mui/material/Button'
import Form from 'react-bootstrap/Form'

import { stringToHash } from '../Misc/FileTools'

import Icons from './Icons/Icons'
import Descriptions from './Descriptions/Descriptions'

import { LiaPepperHotSolid } from "react-icons/lia";

import { parseGIF, decompressFrames } from "gifuct-js";

import { Grid, Paper, Typography, Box, Collapse, IconButton, ClickAwayListener } from '@mui/material';


const layerGroups = [
    {
        name:'Basic',
        type:'basic-layers',
        layers: [
            {
                name:'Image',
                type:'basic-image',
                config:{
                    type:"image",
                    tag:"basic-image",
                    variant:null,
                    disabled:false
                }
            },
            {
                name:'Text',
                type:'basic-text',
                config:{
                    type:"text",
                    tag:"basic-text",
                    variant:null,
                    disabled:false
                }

            },
            {
                name:'Avatar',
                type:'basic-avatar',
                config:{
                    type:"avatar",
                    tag:"basic-avatar",
                    variant:null,
                    disabled:false
                }

            },
            {
                name:'Emoticon',
                type:'basic-emoticon',
                config:{
                    type:"emoticon",
                    tag:"basic-emoticon",
                    variant:null,
                    disabled:false
                }

            },
        ]
    },
    {
        name:'Kingmakers',
        type:'kingmaker-layers',
        layers: [
            {
                name:'RNG King',
                type:'kingmaker-rng-king',
                config:{
                    type:"dyno",
                    tag:"kingmaker-rng-king",
                    variant:"rng_king",
                    disabled:false
                }
                /*
                 * People sign up with #pickme, after #start one person is selected from the ones
                 * that have signed up.
                 */
            },
            {
                name:'Boss slayer',
                type:'kingmaker-boss-slayer',
                config:{
                    type:"dyno",
                    tag:"kingmaker-boss-slayer",
                    variant:"boss_slayer",
                    disabled:false
                }
                /*
                 * A boss picture and hit animation. The boss has a preset health (with or without health bar)
                 * and the viewer can attack the boss with #hit, each hit takes a portion of health from the boss
                 * and with certain probability a hit can be chritial hit. The person that makes the death blow 
                 * becomes the channel king.
                 */
            },
            {
                name:'Trivia King',
                type:'kingmaker-trivia-king',
                config:{
                    type:"dyno",
                    tag:"kingmaker-trivia-king",
                    variant:"trivia_king",
                    disabled:false
                }
                /*
                 * Trivia questions are generated by the LLM model and can be edited by the streamer. The person
                 * who answerss the most questions correctly becomes the king. Random selection if there are multiple 
                 * viewsers with the top score
                 */
            },
            {
                name:'Auction House',
                type:'kingmaker-auction-house',
                config:{
                    type:"dyno",
                    tag:"kingmaker-auction-house",
                    variant:"auction_house",
                    disabled:false
                }
                /*
                 * A virtual currency is needed for this. Can be earned by the number of messages sent througth the 
                 * current stream. The person who makes the highest bid wins the king position.
                 */
            },
            {
                name:'King of the hill',
                type:'kingmaker-king-of-the-hill',
                config:{
                    type:"dyno",
                    tag:"kingmaker-king-of-the-hill",
                    variant:"king_of_the_hill",
                    disabled:false
                }
                /*
                 * There is an overall timer, A certain hashtag places a person at the top. (With an immunity cooldown)
                 * others can bring the first person who sends the new hashtag after the cooldown will be places at the 
                 * top of the hill. After the overall timer is done, the person with the most time at the top of the hill
                 * is declared the channel king.
                 */

            },
            {
                name:'Tournament',
                type:'kingmaker-tournament',
                config:{
                    type:"dyno",
                    tag:"kingmaker-tournament",
                    variant:"king_tournament",
                    disabled:false
                }
                /*
                 * The viewsers signup for this using a hashtag, a bracket tournament is formed and the viewers are 
                 * paired together. At each challenge, The person who sends a certain hashtag is declared the winner 
                 * and moves on to the next round. This is continued until only one viewer is left to be declared 
                 * the king.
                 */
            },
            {
                name:'Quickdraw',
                type:'kingmaker-quickdraw',
                config:{
                    type:"dyno",
                    tag:"kingmaker-quickdraw",
                    variant:"king_quickdraw",
                    disabled:false
                }
                /*
                 * Several strings are prepared by the streamer, a randomly selected string is shown to the viewers 
                 * and the first person who sends back the string is declared the winner. There is a cooldown until 
                 * the next eround.
                 */
            },
        ]
    },
    {
        name:'Echo Chambers',
        type:'echo-chambers-layers',
        layers: [
            {
                name:'Word cloud',
                type:'echo-chambers-word-cloud',
                config:{
                    type:"dyno",
                    tag:"echo-chambers-word-cloud",
                    variant:"word_cloud",
                    disabled:false
                }

                /*
                 * This is a basic word cloud allowing the viewers to send different words to be displayed on the 
                 * in the cloud.
                 */

            },
            {
                name:'Canvas Wall',
                type:'echo-chambers-canvas-wall',
                config:{
                    type:"dyno",
                    tag:"echo-chambers-canvas-wall",
                    variant:"canvas_wall",
                    disabled:false
                }

                /*
                 * A bitmap low resolution canvas allowing the viewers to set the colors of different pixels of 
                 * this canvas.
                 */

            },
            {
                name:'Graffiti Wall',
                type:'echo-chambers-graffiti-wall',
                config:{
                    type:"dyno",
                    tag:"echo-chambers-graffiti-wall",
                    variant:"grafitti_wall",
                    disabled:false
                }

                /*
                 * A wall for users to stick different emoticons to it. 
                 */

            },
            {
                name:'Character Sheet',
                type:'echo-chambers-character-sheet',
                config:{
                    type:"dyno",
                    tag:"echo-chambers-character-sheet",
                    variant:"character-sheet",
                    disabled:false
                }

                /*
                 * A list of different attributes of the streamer for the viewers to vote on 
                 */

            },
            {
                name:'The Constellation',
                type:'echo-chambers-the-constellation',
                config:{
                    type:"dyno",
                    tag:"echo-chambers-the-constellation",
                    variant:"the-constellation",
                    disabled:false
                }

                /*
                 * A black / dark backgorund, for every person who chats we place a random white star on the canvas
                 * when people mention eachother in chat a line is drawn between their stars
                 */
            }
        ]
    },
    {
        name:'Influencer',
        type:'influencer-layers',
        layers: [
            {
                name:'Tug of war',
                type:'influencer-tug-of-war',
                config:{
                    type:"dyno",
                    tag:"influencer-tug-of-war",
                    variant:"tug_a_war",
                    disabled:false
                }

                /*
                 * Moving a slider left or right to reach a goal. Either done by majority voting (updated every minute)
                 * or can be moved by the selected channel king.
                 */
            },
            {
                name:"The selector",
                type:'influencer-the-selector',
                config:{
                    type:"dyno",
                    tag:"influencer-the-selector",
                    variant:"the-selector",
                    disabled:false
                }

                /*
                 * This widgets offers several states to be choosen from. The chose can change based on majority voting 
                 * (updated every minute) or by the selected channel king.
                 */

            },
        ]
    },
    {
        name:'Pulse',
        type:'pulse-layers',
        layers: [
            {
                name:'Emote Podium',
                type:'pulse-emote-podium',
                config:{
                    type:"dyno",
                    tag:"pulse-emote-podium",
                    variant:"emote_podium",
                    disabled:false
                }
                /*
                 * The dominant emote used in the best minute.
                 */
            },
            {
                name:"Hype-O-Meter",
                type:'pulse-hype-o-meter',
                config:{
                    type:"dyno",
                    tag:"pulse-hype-o-meter",
                    variant:"hypo-o-meter",
                    disabled:false
                }
                /*
                 * A meter that shows how fast chats are coming and showing how excited the audience are.
                 */

            },
            {
                name:"AB Testing",
                type:'pulse-ab-testing',
                config:{
                    type:"dyno",
                    tag:"pulse-ab-testing",
                    variant:"ab-testing",
                    disabled:false
                }
                /*
                 * Selecting two characters (A and B) and asking the audience to pick one. We will then show
                 * the character that is most shown by the audience since reset.
                 */

            },
            {
                name:"Hivemind",
                type:'pulse-hivemind',
                config:{
                    type:"dyno",
                    tag:"pulse-hivemind",
                    variant:"hivemin",
                    disabled:false
                }
                /*
                 * Selecting one character as the target character such as F. If the audience agree they should 
                 * send F otherwise send something else. The more people agree on F, the larger would be the 
                 * circle indicator of this widget.
                 */
            },
        ]
    },
    {
        name:'RNG',
        type:'rng-layers',
        layers: [
            {
                name:'Minimal',
                type:'rng-minimal',
                config:{
                    type:"dyno",
                    tag:"rng-minimal",
                    variant:"minimal",
                    disabled:false
                }
                /*
                 * Slot machine for randomly picking one item among a list of items.
                 */
            },
            {
                name:'Slot Machine',
                type:'rng-slot-machine',
                config:{
                    type:"dyno",
                    tag:"rng-slot-machine",
                    variant:"slot_machine",
                    disabled:false
                }
                /*
                 * Slot machine for randomly picking one item among a list of items.
                 */
            },
            {
                name:'Wheel Of Fortune',
                type:'rng-wheel-of-fortune',
                config:{
                    type:"dyno",
                    tag:"rng-wheel-of-fortune",
                    variant:"wheel_of_fortune",
                    disabled:false
                }
                /*
                 * Slot machine for randomly picking one item among a list of items.
                 */
            },

        ]
    },
    {
        name:'Consensus',
        type:'consensus-layers',
        layers: [
            {
                name:'Voting Board',
                type:'consensus-voting-board',
                config:{
                    type:"dyno",
                    tag:"consensus-voting-board",
                    variant:"voting-board",
                    disabled:false
                }
                /*
                 * Slot machine for randomly picking one item among a list of items.
                 */
            },
            {
                name:'Survivor',
                type:'consensus-survivor',
                config:{
                    type:"dyno",
                    tag:"consensus-survivor",
                    variant:"survivor",
                    disabled:false
                }
                /*
                 * We start with a preset list, people have to vote for the items and every two minutes the last 
                 * item is removed.
                 */
            },
            {
                name:'Jukebox',
                type:'consensus-jukebox',
                config:{
                    type:"dyno",
                    tag:"consensus-jukebox",
                    variant:"jukebox",
                    disabled:false
                }
                /*
                 * A preset list of items is provided. A certain number of votes is required to push an item 
                 * to the top. Stepping the widget would remove the top element.
                 */
            },
            {
                name:'Knockout',
                type:'consensus-knockout',
                config:{
                    type:"dyno",
                    tag:"consensus-knockout",
                    variant:"knockout",
                    disabled:false
                }
                /*
                 * Bracket tournament style by putting items against each other. 
                 */
            },


        ]
    }

]

export function MuiLayerGrid( props )
{
    const items = props.items
    const loadWidget = props.loadWidget
    const activeItem = props.activeItem 
    const setActiveItem = props.setActiveItem

    const [selectedType, setSelectedType] = useState(null);
    const [arrowLeftPosition, setArrowLeftPosition] = useState(0); 
    
    // We store a reference to every single card to calculate its exact position
    const itemRefs = useRef({});
    
    const itemsPerRow = 4;

    // Helper to chunk data
    const chunkArray = (arr, size) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
        }
        return chunks;
    };

    const rows = chunkArray(items, itemsPerRow);

    const handleItemClick = (e, type) => {
        e.stopPropagation();
        
        // Toggle logic
        if (selectedType === type) {
            setSelectedType(null);
            return;
        }

        // --- THE PRECISION FIX ---
        // Instead of guessing percentages, we calculate the exact pixel center
        // of the clicked card relative to its row.
        const target = e.currentTarget;
        const center = target.offsetLeft + (target.offsetWidth / 2);
        
        setArrowLeftPosition(center);
        setSelectedType(type);
    };

    const handleClose = () => {
        setSelectedType(null);
    };

    // Recalculate arrow position on window resize so it never drifts
    useEffect(() => {
        const handleResize = () => {
            if (selectedType && itemRefs.current[selectedType]) {
                const target = itemRefs.current[selectedType];
                const center = target.offsetLeft + (target.offsetWidth / 2);
                setArrowLeftPosition(center);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [selectedType]);

    return (
        <ClickAwayListener onClickAway={handleClose}>
            {/* Removed the heavy 'p: 4' padding so items can span the full width */}
            <Box onClick={handleClose} sx={{ width: '100%', pt: 2, pb: 2,  }}>
                {rows.map((rowItems, rowIndex) => {
                    //setActiveItem(rowItems.find(item => item.type === selectedType))
                    const activeItem = rowItems.find(item => item.type === selectedType);
                    return (
                        <Box key={rowIndex} sx={{ mb: 2, position: 'relative' }}>
                            <Grid container spacing={2}>
                                {rowItems.map((item) => (
                                    <Grid size={3}>
                                        <Paper 
                                            ref={el => itemRefs.current[item.type] = el}
                                            elevation={selectedType === item.type ? 3 : 1}
                                            onClick={(e) => handleItemClick(e, item.type)}
                                            sx={{
                                                p: 3,
                                                height: '100%', // Ensures uniform height
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                // Border handling for active state
                                                border: selectedType === item.type 
                                                    ? '2px solid #1976d2' 
                                                    : '2px solid transparent',
                                                bgcolor: selectedType === item.type 
                                                    ? '#e3f2fd' // Light blue bg when active
                                                    : 'background.paper',
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': { 
                                                    transform: 'translateY(-2px)',
                                                    boxShadow: 4
                                                }
                                            }}
                                        > 
                                            <Box sx={{ fontSize: 40, 
                                                       color: 'black', 
                                                       mb: 1, 
                                                       lineHeight: 1 }}
                                            >
                                                <Icons type={item.type} />
                                            </Box>
                                            <Typography variant="subtitle1" fontWeight="bold" fontSize="12px">
                                                {item.name}
                                            </Typography>

                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>

                            <Collapse in={!!activeItem} unmountOnExit>
                                {activeItem && (
                                    <Box 
                                        onClick={(e) => e.stopPropagation()} 
                                        sx={{ position: 'relative', mt: 3, px: 1 }}
                                    >
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: -8,
                                                width: 16,
                                                height: 16,
                                                bgcolor: '#212121',
                                                transform: 'translateX(-50%) rotate(45deg)',
                                                // Use the calculated pixel position
                                                left: arrowLeftPosition, 
                                                transition: 'left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                zIndex: 1
                                            }}
                                        />
                                        
                                        <Paper 
                                            elevation={4} 
                                            sx={{ 
                                                p: 4, 
                                                bgcolor: '#212121', 
                                                color: 'white',
                                                borderRadius: 2
                                            }}
                                        >
                                            <div style={{ marginBottom:'15px' }}>
                                                <Button variant="contained"
                                                        size="small" 
                                                        onClick={(e) => loadWidget(activeItem.config)}
                                                        style={{ textTransform:'none' }}
                                                        disabled={activeItem.config.disabled}
                                                >
                                                    + Add Layer
                                                </Button>
                                            </div>
                                            <Typography variant="body2" sx={{ color: 'grey.400' }}>
                                                {activeItem.description}
                                            </Typography>
                                            <div style={{ fontSize:'12px'}}>
                                                <Descriptions type={activeItem.type} />
                                            </div>
                                        </Paper>
                                    </Box>
                                )}
                            </Collapse>
                        </Box>
                    );
                })}
            </Box>
        </ClickAwayListener>
    );
};

export function ItemButton( props )
{
    const name = props.name
    const selected = props.selected 
    const setSelected = props.setSelected
    const disabled = ( props.disabled == null ) ? false : props.disabled
    
    const [ isHover, setIsHover ] = useState( false )

    if( disabled )
    {
        return (
            <div className="d-flex justify-content-center align-items-center"
                 style={{ height:'60px', width:'100%',
                          border:'',
                          borderRadius:'5px',
                          backgroundColor:'',
                          padding:'10px',
                          color:'grey',
                          ...props.style }}
            >
                {props.children}
            </div>
        )
    }

    return (
        <div className="d-flex justify-content-center align-items-center"
             style={{ height:'60px', width:'100%',
                      border:(isHover) ? '0.2px solid #DADADA' : '',
                      borderRadius:'5px',
                      backgroundColor:(selected == name) ? '#DADADA' : '',
                      padding:'10px',
                      ...props.style }}
             onMouseEnter={e => setIsHover(true)}
             onMouseLeave={e => setIsHover(false)}
             onClick={ e => setSelected(name)}
        >
            {props.children}
        </div>
    )
}

export function ModalBody( props )
{
    const addCloseModal = props.addCloseModal
    const closeModal = props.closeModal 
    const accountType = props.accountType
    
    const [ selected, setSelected ] = useState("")

    const file = useRef(null)
    //const [ file, setFile ] = useState(null)
    const [ fileValue, setFileValue ] = useState("")

    const fileSetter = (v,f ) =>
    {
        setFileValue( v )
        file.current = f

        var fr = new FileReader();

        fr.onload = function() {
            let content =  btoa(fr.result)


            var data = {}
            data.content = content
            data.filename = file.current.name
            data.hash = stringToHash(content)

            //uploadCloseModal( data )
            file.current = data
        }

        fr.readAsBinaryString(file.current);
    }

    const upload = () => {
        if( selected == "" )
        {
            return
        }

        if( file.current == null && selected=="image" )
        {
            closeModal()
            return
        } 

        addCloseModal( selected, file.current )
    }

    return (
        <>
            <Modal.Body>
                <div style={{ width:'100%', height:'290px', padding:'10px'}}>
                    <ItemButton name="image" selected={selected} setSelected={setSelected}
                                style={{ marginBottom:'10px' }}>
                        <Form.Control type="file" value={fileValue} 
                              onChange={(e) => fileSetter( e.target.value, e.target.files[0])}
                              size="sm"
                              style={{ maxWidth:'250px'}}
                        />
                    </ItemButton>

                    <ItemButton name="avatar" selected={selected} setSelected={setSelected}
                                style={{ marginBottom:'10px' }} disabled={accountType=='mild'}>
                        Avatar <LiaPepperHotSolid style={{ marginLeft:'10px'}} />
                    </ItemButton>

                    <ItemButton name="emoticon" selected={selected} setSelected={setSelected}
                                style={{ marginBottom:'10px' }} disabled={accountType=='mild'}>
                        Emoticon <LiaPepperHotSolid style={{ marginLeft:'10px'}}/>
                    </ItemButton> 
                    <ItemButton name="text" selected={selected} setSelected={setSelected}
                                style={{ marginBottom:'10px' }} disabled={accountType=='mild'}>
                        Text <LiaPepperHotSolid style={{ marginLeft:'10px'}}/>
                    </ItemButton>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ border:'none'}}>
                <Button variant="contained" onClick={closeModal} 
                        style={{ marginRight:'5px', textTransform:'none' }} 
                        size="small">Close</Button>
                <Button variant="contained" onClick={upload} style={{ textTransform:'none' }}
                        size="small">Add</Button>
            </Modal.Footer>
        </>
    )
}

export function ButtonFace( props )
{
    const title1 = props.title1 
    const title2 = props.title2
    const icon = props.icon
    const hoverColor = props.hoverColor 

    const [ isHover, setIsHover ] = useState(false)

    return (
        <div style={{ height:'100%', width:'100%', fontSize:11 }}
             onMouseEnter={ e => setIsHover(true)}
             onMouseLeave={ e => setIsHover(false)}
        >
            <div style={{ color: (isHover) ? hoverColor : '#000000' }}>
                <b>{ title1 }</b>
            </div>
            <div>
                { title2 }
            </div>
            <div style={{ fontSize:50, color: (isHover) ? hoverColor : '#000000' }}>
                { icon }
            </div>
            
        </div>
    )
}

export default function AddLayerModal( props )
{
    const showModal = props.showModal 
    const closeModal = props.closeModal 
    const addCloseModal = props.addCloseModal 
    const accountType = props.accountType

    const [ selectedFile, setSelectedFile ] = useState(null)
    const [ activeItem, setActiveItem ] = useState(null)

    const inputRef = useRef(null)

    const update = ( name ) => {
        addCloseModal( name, null )
    }

    useEffect( () => {
        if( showModal )
        {
            setSelectedFile(null)
        }
    },[showModal])

    const openFileDialog = ( config ) => {
        inputRef.current = document.createElement('input');
        inputRef.current.type = 'file';
        inputRef.current.onchange = _this => {
            let file = inputRef.current.files[0];
            setSelectedFile( { config, file } )
        };
        inputRef.current.click();
    }

    const gifDuration = ( content ) => {
        const arrayBuffer = new ArrayBuffer(content.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < content.length; i++) {
            uint8Array[i] = content.charCodeAt(i);
        }

        const gif = new parseGIF(arrayBuffer);
        const frames = decompressFrames(gif,true)

        // Calculate total duration
        let totalDuration = 0;
        frames.forEach(frame => {
            totalDuration += frame.delay; // delay is in hundredths of a second
        });

        return totalDuration;
    }

    useEffect( () => {
        if(selectedFile == null)
        {
            return
        }

        var fr = new FileReader();

        fr.onload = function() {

            try {
                let content =  btoa(fr.result)
                var data = {}
                data.content = structuredClone(content)
                data.filename = structuredClone(selectedFile.file.name)
                data.filetype = structuredClone(selectedFile.file.type) + ";base64"
                data.hash = stringToHash(content)
                data.duration = 0

                if( selectedFile.file.type == "image/gif" )
                {
                    data.duration = gifDuration( fr.result )
                }

                addCloseModal( selectedFile.config, data )
            }
            catch (err)
            {
                console.log(err)
            }
        }

        fr.readAsBinaryString(selectedFile.file);
    }, [selectedFile])

    const loadWidget = ( config ) => {

        if( config.type == "image" )
        {
            openFileDialog( config )

            return
        }

        addCloseModal( config, null )
    }

    return (
        <Modal show={showModal} onHide={closeModal} size="lg">
            <Modal.Body style={{height:'600px', overflowY:'scroll'}}>
                {layerGroups.map( (lg,idx) =>  
                    <div key={idx}>
                        <div style={{ width:'100%', 
                                      backgroundColor:'#D7D7D7',
                                      padding:'5px',
                                      marginBottom:'10px',
                                      borderRadius:'3px',
                                      display:'flex',
                                      justifyContent:'start'
                                    }}>
                            <b>{lg.name}</b>
                        </div>
                        <div style={{width:'100%'}}>
                        <MuiLayerGrid items={lg.layers}
                                      loadWidget={loadWidget}
                                      activeItem={activeItem}
                                      setActiveItem={setActiveItem}
                        />
                        </div>
                    </div>
                )}      
            </Modal.Body>
        </Modal>
    )
}

